import loadable from "utils/loadable";

export const HalamanManageHomepage = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
